import React from 'react';
import {
    Text,
    getFieldValue,
    withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import Image from '@fhs/shared/src/components/Image/Image';
import Link from '../Link';
import DesaturateImage from '../../components-common/DesaturateImage/DesaturateImage';
import './HeroImage.scss';

const HeroImage = (props) => {
    const { fields } = props;
    const image = getFieldValue(fields, 'image');

    const desaturatedFlag = getFieldValue(fields, 'isDesaturated');
    const isDesaturated =
        desaturatedFlag === undefined ||
        (typeof desaturatedFlag === 'boolean' && desaturatedFlag);

    return (
        <div className="hero-image">
            {image && (
                <>
                    <div className="hero-image__media">
                        {isDesaturated ? (
                            <DesaturateImage image={image} />
                        ) : (
                            <Image
                                src={image?.src}
                                alt={image?.alt}
                                classNames={{
                                    picture: 'h-full',
                                }}
                                priority
                                sizes={[
                                    {
                                        w: 400,
                                        media: '(max-width: 400px)',
                                    },
                                    {
                                        w: 720,
                                        media:
                                            '(min-width: 401px) and (max-width: 720px)',
                                    },
                                    {
                                        media: '(min-width: 721px)',
                                    },
                                ]}
                            />
                        )}
                    </div>
                    <div className="hero-image__body">
                        {getFieldValue(fields, 'title') && (
                            <div className="hero-image__title">
                                <Text
                                    field={fields.title}
                                    className="hdg hdg--1"
                                    tag="h1"
                                />
                            </div>
                        )}
                        <div className="vr vr--6x" />
                        {getFieldValue(fields, 'cta') &&
                            fields.cta.value.href &&
                            fields.cta.value.text && (
                                <Link
                                    className="btn btn--primary btn--wide"
                                    linkFieldValue={getFieldValue(
                                        fields,
                                        'cta'
                                    )}
                                />
                            )}
                    </div>
                </>
            )}
        </div>
    );
};

export default withSitecoreContext()(HeroImage);
